var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.4,
    viewBox: "0 0 16 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_copia",
    "data-name": "icona copia",
    transform: "translate(-370 -91.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_copia-2",
    "data-name": "icona copia",
    transform: "translate(322.85 92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1973",
    "data-name": "Raggruppa 1973",
    transform: "translate(48.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_320",
    "data-name": "Tracciato 320",
    d: "M57.353,85.4H49.915a1.266,1.266,0,0,0-1.265,1.265V97.337A1.266,1.266,0,0,0,49.915,98.6h7.438a1.266,1.266,0,0,0,1.265-1.265V86.665A1.27,1.27,0,0,0,57.353,85.4Zm.377,11.934a.38.38,0,0,1-.38.38H49.912a.38.38,0,0,1-.38-.38V86.665a.38.38,0,0,1,.38-.38H57.35a.38.38,0,0,1,.38.38Z",
    transform: "translate(-48.65 -82.602)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_321",
    "data-name": "Tracciato 321",
    d: "M144.153,0h-7.438a1.266,1.266,0,0,0-1.265,1.265.442.442,0,0,0,.885,0,.38.38,0,0,1,.38-.38h7.438a.38.38,0,0,1,.38.38V11.937a.38.38,0,0,1-.38.38.442.442,0,1,0,0,.885,1.266,1.266,0,0,0,1.265-1.265V1.265A1.266,1.266,0,0,0,144.153,0Z",
    transform: "translate(-132.606)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_786",
    "data-name": "Rettangolo 786",
    transform: "translate(370 92)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.12ad71f12d3fe510e148244aaaf69dbe.svg";
export { ForwardRef as ReactComponent };